module.exports = __webpack_public_path__ + "img/facebook.b45700b4.svg";